import { gsap } from "../gsap/all.js";
import { ScrollTrigger } from "../gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);
gsap.config({nullTargetWarn:false});
export default {

  init() {

    // Init Q1 Load

    const questions = document.querySelectorAll('.question')
    const q1 = document.querySelector('.q1')
    const q1s = document.querySelectorAll('.q1 ul li')
    const q2a = document.querySelector('.q2a')
    const q2as = document.querySelectorAll('.q2a ul li')
    const q2b = document.querySelector('.q2b')
    const q2bs = document.querySelectorAll('.q2b ul li')
    const q2c = document.querySelector('.q2c')
    const q2cs = document.querySelectorAll('.q2c ul li')
    const q3a = document.querySelector('.q3a')
    const q3as = document.querySelectorAll('.q3a ul li')
    const q3b = document.querySelector('.q3b')
    const q3bs = document.querySelectorAll('.q3b ul li')
    const q3c = document.querySelector('.q3c')
    const q3cs = document.querySelectorAll('.q3c ul li')
    const q3d = document.querySelector('.q3d')
    const q3ds = document.querySelectorAll('.q3d ul li')
    const q3e = document.querySelector('.q3e')
    const q3es = document.querySelectorAll('.q3e ul li')
    const back = document.querySelectorAll('.back')
    const slidesInner = document.querySelector('.slides-inner')
    var selection1
    var selection2
    var selection3
    var selection4
    var style
    var slides
    var backSelect
    var dataCurrent

    q1.classList.add('selected');

    // Listen For Q1 Action

    for (let i = 0; i < q1s.length; i++) {
     q1s[i].addEventListener('click', function() {
       selection1 = q1s[i].getAttribute('data-flow')
       q1.classList.remove('selected')
       this.closest('.question').classList.add('set')
       setQ1(selection1)
     });
   }

   // Listen For CX Action

   for (let i = 0; i < q2as.length; i++) {
     q2as[i].addEventListener('click', function() {
       selection2 = q2as[i].getAttribute('data-flow')
       q2a.classList.remove('selected')
       this.closest('.question').classList.add('set')
       setQ2(selection2)
     });
   }

   // Listen For EX Action

   for (let i = 0; i < q2bs.length; i++) {
     q2bs[i].addEventListener('click', function() {
       selection2 = q2bs[i].getAttribute('data-flow')
       q2b.classList.remove('selected')
       this.closest('.question').classList.add('set')
       setQ2(selection2)
     });
   }

   // Listen for OpEx Action

   for (let i = 0; i < q2cs.length; i++) {
     q2cs[i].addEventListener('click', function() {
       selection4 = q2cs[i].getAttribute('data-flow')
       q2c.classList.remove('selected')
       this.closest('.question').classList.add('set')
       setQ2(selection4)
     });
   }


   // Listen For Slides Clicks

   for (let i = 0; i < q3as.length; i++) {
     q3as[i].addEventListener('click', function() {
       slides = q3as[i].getAttribute('data-slides')
       style = q3as[i].getAttribute('data-style')
       openSlides(slides, style)
     });
   }

   for (let i = 0; i < q3cs.length; i++) {
     q3cs[i].addEventListener('click', function() {
       slides = q3cs[i].getAttribute('data-slides')
       style = q3cs[i].getAttribute('data-style')
       openSlides(slides, style)
     });
   }

   for (let i = 0; i < q3es.length; i++) {
     q3es[i].addEventListener('click', function() {
       slides = q3es[i].getAttribute('data-slides')
       style = q3es[i].getAttribute('data-style')
       openSlides(slides, style)
     });
   }

   for (let i = 0; i < q3bs.length; i++) {
     q3bs[i].addEventListener('click', function() {
       slides = q3bs[i].getAttribute('data-slides')
       style = q3bs[i].getAttribute('data-style')
       openSlides(slides, style)
     });
   }

   for (let i = 0; i < q3ds.length; i++) {
     q3ds[i].addEventListener('click', function() {
       slides = q3ds[i].getAttribute('data-slides')
       style = q3ds[i].getAttribute('data-style')
       openSlides(slides, style)
     });
   }


   // Listen for back button clicks

   for (let i = 0; i < back.length; i++) {
     back[i].addEventListener('click', function() {
       backSelect = back[i].getAttribute('data-return')
       dataCurrent = back[i].getAttribute('data-current')
       goBack(backSelect, dataCurrent)
     });
   }

   // Slide Closer/Cleaner

   document.addEventListener('click', function(event) {
    if (event.target.classList.contains('back-slides')) {
      setTimeout(() => {
        $('.slides').removeClass('active')
        $('.slides-inner').html('')
        $('.slides').removeClass('base orange blue lt-blue dk-blue')
      }, 1200)
    }
  })

  $('.body').on('click', '.back-slides', function() {
    $('.slides').removeClass('active')
  });



   function setQ1(val) {
    if (val === 'opex') {
      document.querySelector('.q3e').classList.add('selected')
    } else {
      document.getElementById(val).classList.add('selected')
    }
    // localStorage.setItem('q1', val)
  }

  function setQ2(val) {
    console.log(val)
    document.getElementById(val).classList.add('selected')
    // localStorage.setItem('q2', val)
  }

  function openSlides(val, style) {
    document.querySelector('.slides').classList.add('active')
    document.querySelector('.slides').classList.add(style)

    $.ajax({
      type: 'POST',
      url: ajaxurl,
      data: {
        action: 'load_slides',
        slide: val,
      },
      success: function (response) {
        const parsedResponse = JSON.parse(response);
        $('.slides-inner').html(parsedResponse.html);
        setTimeout(() => {
          if (localStorage.getItem('isSubmitted') !== 'true') {
            $('#mainForm').foundation('open');
            MktoForms2.whenReady( function (form) {
              form.vals({'searchPathForm': val});
            });
          }
        }, 5000);
      },
      error: function (errorThrown) {
        console.log(errorThrown);
      },
    });
  }

  function goBack(loc, curr) {
    document.querySelector(`.${curr}`).classList.remove('selected')
    document.querySelector(`.${loc}`).classList.remove('set')
    document.querySelector(`.${loc}`).classList.add('selected')
    localStorage.setItem(loc, '')
  }

  $('body').on('click', '.thelink', function(event) {
    $('.slides.active').scrollTop(0);
    $(this).next().show();
    $('.slides').addClass('modal-active');
    event.preventDefault();
  });

  $('body').on('click', '.close-button', function(event) {
    $(this).parent().hide();
    $('.slides').removeClass('modal-active');
    event.preventDefault();
  });

  // Marketo TY Page Bypass

  MktoForms2.whenReady(function (form) {
   form.onSuccess(function(values, followUpUrl) {
    $('#mainForm').foundation('close');
    localStorage.setItem('isSubmitted', 'true')
    return false;
  });

 });


},
finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js